<template>
  <div class="country-selection">
    <label class="form-label">
      {{ $t("issuance_reporting.file_upload.country_label") }}
      <span class="text-danger">*</span>
    </label>
    <select
      :value="model"
      @input="handleInput"
      class="form-select"
      :disabled="disabled"
    >
      <option value="">
        {{ $t("issuance_reporting.file_upload.select_country") }}
      </option>
      <option value="ES">
        {{ $t("issuance_reporting.file_upload.countries.ES.label") }}
      </option>
      <option value="PL">
        {{ $t("issuance_reporting.file_upload.countries.PL.label") }}
      </option>
    </select>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  disabled?: boolean;
}>();

const model = defineModel<string>({ required: true });

const handleInput = (event: Event) => {
  const target = event.target as HTMLSelectElement;
  model.value = target.value;
};
</script>

<style scoped lang="scss">
.country-selection {
  .form-label {
    font-weight: 500;
    margin-bottom: 0.5rem;
  }
}
</style>
